import React from 'react';
import { FormControl, FormLabel, TextField } from '@material-ui/core';

const DemoQuestiontext = ({name, type = 'text', label = '', className = '', required = false, requiredError = '', isVisible = true, placeholder = '', value = '', onChange, validationMessage = undefined, inputProps = {}, helperText = '' }) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div className={'form-group' + (required && requiredError ? ' required' : '')}>
            <FormLabel className="demo-error" component="legend">{validationMessage}</FormLabel>
            <FormControl className="demo-control demo-text" component="fieldset">
                {label && <FormLabel className="demo-label" component="legend">{label}{required && <span className="label-required">*</span>}</FormLabel>}
                <TextField
                    name={name}
                    type={type}
                    autoComplete="off"
                    placeholder={placeholder}
                    value={value}
                    valid={validationMessage && validationMessage.length > 0 ? validationMessage : ''}
                    variant="outlined"
                    onChange={onChange}
                    inputProps={inputProps}
                    helperText={helperText}
                />
                {required && requiredError && <div className="required-error">Required</div>}
            </FormControl>
        </div>
    )
}

export default DemoQuestiontext;